import { combineReducers } from 'redux'
import loginReducer from '../routes/Login/reducer'
import signupReducer from '../routes/SignUp/reducer';
import loginLayoutReducer from '../layouts/LoggedIn/reducer'
import roomReducer from '../routes/Room/reducer'
import usersReducer from '../routes/Users/reducer'
import activityLogsReducer from '../routes/ActivityLogs/reducer'
import settingsReducer from '../routes/Settings/reducer'
import resetReducer from '../routes/ResetPassword/reducer'
import planReducer from '../components/PlanDetails/reducer'
import templateReducer from '../routes/Domain/reducer'
import mangePlansReducer from '../routes/ManagePlans/reducer';
import manageIpAddressReducer from '../routes/ManageIpAddress/reducer';
import roomRecordingsReducer from '../routes/RoomRecordings/reducer'
import transcriptionReducer from '../routes/Transcriptions/reducer'
import emailAddressBookReducer from '../routes/EmailAddressBook/reducer';
import questionnaireReducer from '../routes/Questionnaire/reducer';
import invitationsReducer from '../routes/Invitations/reducer';
import problemReportReducer from '../routes/ProblemReports/reducer';
// we used combineReducers() to combine several reducers into one
const reducer = combineReducers({
  login: loginReducer,
  signup: signupReducer,
  loginLayout: loginLayoutReducer,
  rooms: roomReducer,
  settings: settingsReducer,
  reset: resetReducer,
  planDetails: planReducer,
  users: usersReducer,
  activityLogs: activityLogsReducer,
  managePlans: mangePlansReducer,
  manageIpAddress: manageIpAddressReducer,
  roomRecordings: roomRecordingsReducer,
  questionnaires: questionnaireReducer,
  transcriptions: transcriptionReducer,
  emailAddressBook: emailAddressBookReducer,
  invitations: invitationsReducer,
  templateReducer,
  problemReports: problemReportReducer
})

export default reducer



// WEBPACK FOOTER //
// src/config/reducer.js